import { FunctionalComponent, h } from "preact";
import { useState } from "preact/hooks";
import { CheckIcon } from "../../../icons/Check";
import { DollarIcon } from "../../../icons/Dollar";
import { FlameIcon } from "../../../icons/Flame";
import { LockIcon } from "../../../icons/Lock";
import { PlusIcon } from "../../../icons/Plus";
import { CheckButton, FlameContainer, FlameIconStyled, ImageStyled, InfoStyled, RewardOfferItemContent, PlusButton, RewardOfferContentLocked, LockButton, OfferCheckButton } from "./reward-offer-item.style";
import { RewardOfferItemI, RewardStatus, ItemType, OfferStatus } from "./reward-offer-item.types";

export const RewardOfferItem: FunctionalComponent<{ openModal: (data: any) => void, callbackTapForDetails: (data: any) => void, rewardOfferItem: RewardOfferItemI, itemType: ItemType }> = ({
  openModal,
  callbackTapForDetails,
  rewardOfferItem,
  itemType
}) => {
  const [item, setItem] = useState(rewardOfferItem);
  const bgColorFlameContainerRewards: string = '#95B040';
  const bgColorFlameContainerOffers: string = '#F6BD45';

  const tapOpenModal = (id: number, e: any) => {
    openModal({ id, e });
  };

  const tapForDetails = (id: number, e: any) => {
    callbackTapForDetails({ id, e });
  };

  return (

    <RewardOfferItemContent>
      <InfoStyled>
        <span class="top-title">{item.topTitle}</span>
        <span class="bottom-title" dangerouslySetInnerHTML={{
          __html: item.bottomTitle
        }}></span>
        {item.expirationDate && (
          <span class="bottom-title-detail">EXPIRES {item.expirationDate.toLocaleDateString('en-US')} </span>
        )}
        <span class="call-to-action" onClick={tapForDetails.bind(this, item.id)} >{item.callToActionText} </span>
      </InfoStyled>
      <ImageStyled>
        <img src={item.leftImageUrl} alt="" />
      </ImageStyled>

      <FlameContainer enableOpacity={false} color={(itemType === ItemType.Reward ? bgColorFlameContainerRewards : bgColorFlameContainerOffers)}>
        <FlameIconStyled>
          {itemType === ItemType.Reward && (
            <FlameIcon></FlameIcon>
          )}
          {itemType === ItemType.Offer && (
            <DollarIcon></DollarIcon>
          )}
        </FlameIconStyled>
      </FlameContainer>
      <FlameContainer enableOpacity={true} color={(itemType === ItemType.Reward ? bgColorFlameContainerRewards : bgColorFlameContainerOffers)}></FlameContainer>

      {item.status === RewardStatus.Active && (
        <PlusButton onClick={tapOpenModal.bind(this, item.id)}>
          <PlusIcon></PlusIcon>
          <span>Redeem</span>
        </PlusButton>
      )}

      {item.status === RewardStatus.Locked && (
        <LockButton>
          <LockIcon></LockIcon>
        </LockButton>
      )}

      {item.status === RewardStatus.Redeemed && (
        <CheckButton>
          <CheckIcon></CheckIcon>
          <span>Redeemed</span>
        </CheckButton>
      )}

      {item.status === OfferStatus.Active && (
        <PlusButton onClick={tapOpenModal.bind(this, item.id)}>
          <PlusIcon></PlusIcon>
          <span>Save</span>
        </PlusButton>
      )}

      {item.status === OfferStatus.Saved && (
        <OfferCheckButton>
          <CheckIcon></CheckIcon>
          <span>Saved</span>
        </OfferCheckButton>
      )}

      {item.status === RewardStatus.Locked && (
        <RewardOfferContentLocked></RewardOfferContentLocked>
      )}
    </RewardOfferItemContent>

  );
};